export const INSTRUMENTAL_RECOMMENDED_THRESHOLD = 0.2;
export const INSTRUMENTAL_AUTO_THRESHOLD = 0.4;

export const REVERB_RECOMMENDED_THRESHOLD = 0.004;
export const REVERB_AUTO_THRESHOLD = 0.03;

export const EFFECTS_DETECTION_SEGMENT_DURATION_S = 2;
export const PITCH_ANALYSIS_SEGMENT_DURATION_S = 60;

// Model training audio can be up to 30 min, so we split it into 3-minute chunks and send the highest-energy 2s of each chunk to the backend in one request.
export const MODEL_EFFECTS_CHUNK_DURATION_S = 180;

export const ENERGY_WINDOW_STEP_SECONDS = 0.1;

// Vocal-band passband — captures fundamentals and lower formants of typical adult voices while attenuating sub-bass / kick drums (below 80 Hz) and hi-hats / cymbals (above 3500 Hz).
export const VOCAL_BAND_HIGHPASS_HZ = 80;
export const VOCAL_BAND_LOWPASS_HZ = 3500;

export const RMS_WINDOW_SECONDS = 0.05;
// Minimum duration the smoothed RMS must stay above threshold before we call it a vocal onset — avoids triggering on transient consonants, breaths, or short stabs.
export const SUSTAIN_REQUIRED_SECONDS = 1.0;
// Noise floor estimated as a low percentile of per-window RMS — robust to occasional silent stretches and intermittent loud passages.
export const NOISE_FLOOR_PERCENTILE = 0.1;
// Onset threshold expressed as a multiple of the noise floor.
export const VOCAL_ONSET_THRESHOLD_MULTIPLIER = 4;
// Hard cap on how much of the buffer we filter+render to find the onset. Onsets that haven't started inside this window almost certainly indicate a non-vocal track; rendering the full multi-minute buffer is wasted CPU.
export const ONSET_SEARCH_MAX_SECONDS = 90;

export const OPUS_BITRATE_BPS = 24000;
export const OPUS_TARGET_SAMPLE_RATE_HZ = 16000;
export const OPUS_TARGET_CHANNELS = 1;

export const PITCH_WINDOW_MIN_SIZE = 7;
export const PITCH_WINDOW_EDGE_PADDING = 2;

export const PITCH_SLIDER_MIN = -24;
export const PITCH_SLIDER_MAX = 24;
export const PITCH_SLIDER_RANGE = PITCH_SLIDER_MAX - PITCH_SLIDER_MIN;

// Descriptions shown under an uploaded file when the quality check detects instruments/reverb. The model description's follow-up sentence with the isolate link lives in the component — it needs JSX.
export const BAD_AUDIO_MODEL_DESCRIPTION =
  "Your audio contains instruments and/or reverb. For best results, use a dry, monophonic recording.";
export const BAD_AUDIO_CONVERSION_DESCRIPTION =
  "This tool requires a dry, monophonic vocal recording. If your audio includes instruments, backing vocals, reverb/echo or noise, use the isolation settings.";

export const AUDIO_QUALITY_CHECK_STATUS = {
  skipped: "skipped",
  pending: "pending",
  complete: "complete",
} as const;

// Labels are sentence case; the badge applies CSS `uppercase` for visual consistency.
export const PITCH_RECOMMENDATION = {
  sweetSpot: { label: "Sweet spot", dotColor: "green" as const },
  great: { label: "Great", dotColor: "green" as const },
  okay: { label: "Okay", dotColor: "yellow" as const },
  likelyTooLow: { label: "Likely too low", dotColor: "red" as const },
  likelyTooHigh: { label: "Likely too high", dotColor: "red" as const },
} as const;
